/** Roles donde el partner debe indicar horario operativo (alta Partner y solicitudes de rol). */
export const PARTNER_SCHEDULE_ROLE_KEYS = ['store', 'pickup', 'venue'];

export function roleNeedsPartnerSchedule(roleKey) {
  return PARTNER_SCHEDULE_ROLE_KEYS.includes(roleKey);
}

export const PARTNER_SCHEDULE_OPTIONS = [
  { value: 'standard', title: 'Horario comercial', desc: 'Estándar comercial de la zona', icon: 'calendar' },
  { value: '24h', title: '24 horas', desc: 'Siempre disponible', icon: 'bell' },
  { value: 'special', title: 'Horario especial', desc: 'Consultar con el Partner', icon: 'chat' },
];

export function normalizePartnerScheduleValue(raw) {
  return raw === '24h' || raw === 'special' || raw === 'standard' ? raw : 'standard';
}
